/* @flow */
import * as React from 'react';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import VirtualizedSelect from 'react-virtualized-select';

//----------------------------------------------------------------------//
// MATERIAL UI.                                                         //
//----------------------------------------------------------------------//

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './ElectroSelect.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
@observer
export default class ElectroSelect extends React.Component<*> {
  /*eslint-disable max-len*/

  @observable isFocused: boolean = false;

  @action toggleFocus = () => {
    this.isFocused = !this.isFocused;
  };

  setResult = (value: Object) => {
    this.props.field.set('value', value || null);

    if (this.props.model) {
      this.props.model.setResult(value || null);
    }
  };

  render(): React.Element<*> {
    const {
      field,
      model,
      disabled,
      searchable,
      simpleValue,
      multi,
      options,
      labelKey,
      valueKey,
      value,
      onChange,
      selectUp,
      t,
    }: any = this.props;

    const isFocusedClass: string = this.isFocused ? styles['is-focused'] : '';
    const isErrorClass: string = field.error ? styles['is-error'] : '';
    const isDisabledClass: string = disabled ? styles['is-disabled'] : '';
    const isRequired: boolean = Boolean(field.rules && field.rules.includes('required'));

    let props: Object;

    if (model) {
      props = {
        ...field.bind({ model }),
        async: true,
        isLoading: model.loading,
        loadOptions: (): void => model.loadData(),
      };
    } else {
      props = {
        ...field.bind(),
        options: options || field.options,
      };
    }

    return (
      <div
        className={`${
          styles['electro-select']
        } ${isFocusedClass} ${isErrorClass} ${isDisabledClass}`}
      >
        {// searchable is set to true by default as part of VirtualizedSelect
        // set false to disable || set true to add calendar icon
        searchable && (
          <svg className={styles['search-icon']}>
            <use xlinkHref="#icon-search" />
          </svg>
        )}
        <FormControl disabled={disabled}>
          {
            <InputLabel
              className={styles['custom-placeholder']}
              required={isRequired}
              shrink={Boolean(
                field.value || field.key === 'other' || this.isFocused || field.error
              )}
            >
              {field.label}
            </InputLabel>
          }
          <VirtualizedSelect
            {...props}
            arrowRenderer={() => (
              <svg className={styles['dropdown-icon']}>
                <use xlinkHref="#icon-drop-arrow-down" />
              </svg>
            )}
            className={`${styles['electro-select-field']} ${selectUp ? 'Select-up' : ''}`}
            clearable={false}
            simpleValue={simpleValue}
            searchable={searchable}
            multi={multi}
            required={isRequired}
            helperText={field.showError ? field.error : ''}
            noResultsText={t('general:search_results.no_results_found')}
            loadingPlaceholder=""
            onChange={onChange || this.setResult}
            onFocus={this.toggleFocus}
            onBlur={this.toggleFocus}
            inputProps={{
              autoComplete: 'off',
            }}
            placeholder={null}
            disabled={disabled}
            name={field.name}
            value={value || field.value || null}
            labelKey={labelKey || 'name'}
            valueKey={valueKey || 'name'}
          />
          {field.error && <FormHelperText error={true}>{field.error}</FormHelperText>}
        </FormControl>
      </div>
    );
  }
}
